module.exports = __webpack_public_path__ + "hat-blueprint-deep.5ba10adf7539e78a0554.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/hat-blueprint-deep.svg
// module id = ../../../../../src/assets/img/hat-blueprint-deep.svg
// module chunks = main